import { memo, useRef } from 'react'
// Material
import { Stack } from '@mui/material'
import { styled } from '@mui/material/styles'
import { RoomTypes } from '@weblite/ts-action/room'
import { BackButton } from '$common/buttons'
import { SearchButton } from '$common/buttons/search-button'
import { useIsDesktopSize } from '$common/react-hooks/layout'
import { ROOM_APP_BAR_HEIGHT } from '$common/room-app-bar/conf'
import { ChannelAppBar } from './components/channel-app-bar'
import { GroupAppBar } from './components/group-app-bar'
import { PvAppBar } from './components/pv-app-bar'
import { PrivateSpaceAppBar } from './components/private-space-app-bar'
import { WappRoomAppBar } from './components/wapp-room-app-bar'
import { sendFieldApis } from '$comp/_app/components/chat/components/footer/components/send-field'

const StyledStack = styled(Stack)<{ background?: string }>(
  ({ theme, background }) => ({
    textAlign: 'right',
    flexShrink: 0,
    overflow: 'hidden',
    backgroundColor: background || theme.palette.neutral000,
    padding: '4px 7px',
    boxSizing: 'border-box',
    color: background ? theme.palette.white : theme.palette.neutral900,
    height: `${ROOM_APP_BAR_HEIGHT}px`,
    borderBottom: '1px solid',
    borderColor: theme.palette.neutral300,
  }),
)

interface Props {
  roomId: string
  roomType: RoomTypes
  onBack: () => unknown
  onSearch: () => unknown
  backgroundColor?: string
}
export const RoomAppBar = memo(function RoomAppBarComponent({
  onBack,
  roomId,
  roomType,
  onSearch,
  backgroundColor,
}: Props) {
  const backButtonRef = useRef<HTMLButtonElement>(null)
  const isDesktop = useIsDesktopSize()

  return (
    <StyledStack background={backgroundColor}>
      <Stack direction="row" alignItems="center">
        {!isDesktop && (
          <BackButton
            color="inherit"
            ref={backButtonRef}
            onClick={async () => {
              const isRecording = await sendFieldApis.checkVoiceStatus()
              if (isRecording) return
              backButtonRef.current?.blur()
              onBack()
            }}
          />
        )}

        {roomType === 'CHANNEL' ? (
          <ChannelAppBar roomId={roomId} />
        ) : roomType === 'GROUP' ? (
          <GroupAppBar roomId={roomId} />
        ) : roomType === 'PV' ? (
          <PvAppBar roomId={roomId} />
        ) : roomType === 'PRIVATE_SPACE' ? (
          <PrivateSpaceAppBar />
        ) : roomType === 'WAPP_ROOM' ? (
          <WappRoomAppBar roomId={roomId} />
        ) : null}
        <SearchButton onClick={onSearch} backgroundColor={backgroundColor} />
      </Stack>
    </StyledStack>
  )
})
